<aside class="sidenav">
    <div class="sidenav-header" [tabIndex]="0"
         [attr.aria-label]="('SCREEN_READER.MENU_OPEN' | translate) + (title$ | async)">
        <p class="sidenav-header__title">{{title$ | async}}</p>
        <app-button *ngIf="!hideCloseIcon"
                    [ariaLabel]="('GENERAL.CLOSE' | translate) + ('GENERAL.MENU' | translate) + ('GENERAL.BUTTON' | translate)"
                    [cssClasses]="'icon'"
                    [icon]="'close'"
                    [iconColor]="'gray-08'"
                    (buttonClicked)="closeEvent.emit($event)">
        </app-button>
    </div>
    <div class="sidenav-content">
        <div class="button-wrapper" *ngIf="showPrimaryMenuButton">
            <app-button
                    [cssClasses]="'btn solid__blue-02 full-width'"
                    [ariaLabel]="primaryMenuButtonText"
                    [icon]="primaryMenuButtonIcon"
                    (buttonClicked)="emitPrimaryMenuButtonEvent.emit()">
                {{primaryMenuButtonText}}
            </app-button>
        </div>
        <app-cms-outline
                [attr.aria-expanded]="true"
                [treeData]="treeData"
                [currentUnitOrderId]="currentUnitOrderId"
                [listClickable]="true"
                (emitClickedElement)="showElementEvent.emit($event)"
                (unitLevelUpEvent)="unitLevelUpEvent.emit($event)"
                (unitLevelDownEvent)="unitLevelDownEvent.emit($event)"
                (moveUnitEvent)="moveUnitEvent.emit($event)"
                (unitDeleteEvent)="unitDeleteEvent.emit($event)"
                (unitRelevanceEvent)="unitRelevanceEvent.emit($event)">
        </app-cms-outline>
    </div>
</aside>
